import { useEffect, useState } from "react";
import { Dropdown, DropdownItemProps, DropdownProps } from "semantic-ui-react";
import dataFormatUtil from "../util/dataFormatUtil";

interface IProps {
    intervalMinutes?: number;
    minMinutes?: number;
    maxMinutes?: number;
    style?: React.CSSProperties;
    valueInMinutes?: number;
    onChange: (valueInMinutes: number | undefined) => void
}

const TimeOfDayPicker: React.FC<IProps> = (props: IProps) => {
    const [valueInMinutes, setValueInMinutes] = useState<number | undefined>(props.valueInMinutes);

    useEffect(() => {
        //Sync internal state when prop changes
        setValueInMinutes(props.valueInMinutes);
    }, [props.valueInMinutes]);

    const minValue = props.minMinutes ?? 0;
    const maxValue = props.maxMinutes ?? 1435; // 23 * 60 + 55
    const interval = props.intervalMinutes ?? 15;

    const minuteOptions = getMinuteOptions(minValue, maxValue, interval);
    const dropdownOptions = getOptionProps(minuteOptions, props.valueInMinutes);

    return <Dropdown
        placeholder=" " //Needed to make alignment with other drop downs work, due to magic HTML element in the div that is the drop down.
        options={dropdownOptions}
        style={props.style}
        clearable={true}
        selection
        search
        compact
        onChange={(_, dropDownProps: DropdownProps) => {
            const numericVal = dropDownProps.value as number;
            setValueInMinutes(numericVal);
            props.onChange(numericVal);
        }}
        value={valueInMinutes} />;

    function getMinuteOptions(minValue: number, maxValue: number, interval: number): number[] {
        const options: number[] = [];
        for (let i = minValue; i <= maxValue; i += interval) {
            options.push(i);
        }
        return options;
    }

    function getOptionProps(options: number[], currentValue: number | undefined) : DropdownItemProps[]{
        return options.map(option => ({
            key: option,
            text: dataFormatUtil.formatToTimeOfDayDisplayType(option),
            value: option,
            selected: (currentValue === option)
        }));
    }
}

export default TimeOfDayPicker;